
export type AgTechSideNavigationCollapseIconProps = {
    isCollapsed: boolean,
    toggleCollapsed: () => void
}

const AgTechSideNavigationCollapseIcon = (props: AgTechSideNavigationCollapseIconProps) => {
    const iconClass = props.isCollapsed ? 'rotate-180' : '';

    return (
        <div className='h-[40px] mt-auto'>
            <i
                className={`fas fa-angle-double-left absolute bottom-[16] right-[28px] transition-transform duration-300 text-appSideNavFont text-xl cursor-pointer color-changing hover:text-highlight ${iconClass}`}
                onClick={() => props.toggleCollapsed()}
            />
        </div>
    )
}

export default AgTechSideNavigationCollapseIcon